import { useEffect } from 'react'
import { useHistory } from '../useHistory'

export type UseLoadingPageRedirectProps = {
  loggedIn: boolean
  loading: boolean
  loggedInPath: string
  loggedOutPath: string
}

/**
 * The landing page's redirect: once the viewer has resolved, a signed-in user goes to `loggedInPath`
 * and a signed-out one to `loggedOutPath`. A browser with no stored user id sends no `me` request
 * (`useUser` skips it), so no 401 ever reaches the Apollo error link — this redirect is the only
 * thing that takes a signed-out visitor off the page.
 */
export const useLoadingPageRedirect = ({
  loggedIn,
  loading,
  loggedInPath,
  loggedOutPath,
}: UseLoadingPageRedirectProps): void => {
  const history = useHistory()

  useEffect(() => {
    if (loading) return

    // replace, not push: Back from the target would land on this page and bounce again
    // (precedent: apps/totalmilk/hauler/admin/src/view/account/join/index.tsx:75)
    history.push(loggedIn ? loggedInPath : loggedOutPath, { replace: true })
  }, [loading, loggedIn, loggedInPath, loggedOutPath, history])
}
